import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function TermsOfUse() {
  return (
    <div className="bg-gradient-to-br from-background to-muted/50 min-h-screen py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="mb-6">
          <Link to="/">
            <Button variant="ghost" className="mb-4">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Home
            </Button>
          </Link>
        </div>
        
        <Card className="shadow-lg bg-gradient-card border-primary/10">
          <CardHeader className="text-center">
            <CardTitle className="text-3xl font-bold text-foreground">Terms of Use</CardTitle>
            <p className="text-muted-foreground text-sm">Last updated: {new Date().toLocaleDateString()}</p>
          </CardHeader>
          <CardContent className="prose prose-slate max-w-none dark:prose-invert">
            <div className="space-y-6">
              <section>
                <h2 className="text-xl font-semibold text-foreground mb-3">1. Agreement to Terms</h2>
                <p className="text-muted-foreground">
                  By using our application, you agree to be bound by these Terms of Use. If you do not agree to these terms, do not use the application.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground mb-3">2. Intellectual Property Rights</h2>
                <p className="text-muted-foreground">
                  The Service and its original content, features, and functionality are and will remain the exclusive property of Edugogy and its licensors.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground mb-3">3. User Accounts</h2>
                <p className="text-muted-foreground">
                  When you create an account with us, you must provide us information that is accurate, complete, and current at all times. Failure to do so constitutes a breach of the Terms, which may result in immediate termination of your account on our Service.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground mb-3">4. Prohibited Activities</h2>
                <p className="text-muted-foreground mb-3">You may not access or use the Service for any purpose other than that for which we make the Service available. Prohibited activity includes, but is not limited to:</p>
                <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                  <li>Systematically retrieving data or other content from the Service to create or compile, directly or indirectly, a collection, compilation, database, or directory without written permission from us.</li>
                  <li>Engaging in any automated use of the system, such as using scripts to send comments or messages, or using any data mining, robots, or similar data gathering and extraction tools.</li>
                  <li>Interfering with, disrupting, or creating an undue burden on the Service or the networks or services connected to the Service.</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground mb-3">5. Termination</h2>
                <p className="text-muted-foreground">
                  We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground mb-3">6. Governing Law</h2>
                <p className="text-muted-foreground">
                  These Terms shall be governed and construed in accordance with the laws of the state in which Edugogy is headquartered, without regard to its conflict of law provisions.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-foreground mb-3">7. Contact Us</h2>
                <p className="text-muted-foreground">
                  If you have any questions about these Terms, please contact us at{' '}
                  <a href="mailto:support@edugogy.com" className="text-primary hover:text-primary/80 underline">
                    support@edugogy.com
                  </a>
                  .
                </p>
              </section>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}